import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, glowFocus, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['DatePicker', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      background: `${glass.input} !important`,
      borderColor: `${navy[700]} !important`,
      color: `#e2e8f0 !important`,

      '&:hover': {
        borderColor: `${blue[500]}60 !important`,
      },

      [`&${componentCls}-focused`]: {
        borderColor: `${blue[500]} !important`,
        boxShadow: `${glowFocus} !important`,
      },

      [`${componentCls}-input > input`]: {
        color: `#e2e8f0 !important`,
      },

      [`${componentCls}-input > input::placeholder`]: {
        color: `#475569 !important`,
      },

      [`${componentCls}-suffix, ${componentCls}-clear`]: {
        color: `#94a3b8 !important`,
      },

      [`${componentCls}-range-separator`]: {
        color: `#64748b !important`,
      },
    },
  }
})
